var render = function render(_c,_vm){return _c('div',_vm._g(_vm._b({ref:_vm.data.ref,staticClass:"rich-text",class:[
    _vm.data.class,
    _vm.data.staticClass,
    { 'rich-text--standard': _vm.props.standard }
  ],style:([_vm.data.style, _vm.data.staticStyle])},'div',_vm.data.attrs,false),_vm.listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }